import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import {
    FAILURE_SEPA_PAYMENTS,
    FAILURE_SEPA_PAYMENT_DETAILS,
    REQUEST_SEPA_PAYMENTS,
    REQUEST_SEPA_PAYMENT_DETAILS,
    SUCCESS_SEPA_PAYMENTS,
    SUCCESS_SEPA_PAYMENT_DETAILS,
} from './actions';

export function sepaReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_SEPA_PAYMENTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SEPA_PAYMENTS: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_SEPA_PAYMENTS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function sepaDetailReducerAdmin(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_SEPA_PAYMENT_DETAILS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SEPA_PAYMENT_DETAILS:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_SEPA_PAYMENT_DETAILS:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
